document.documentElement.classList.remove('no-js');
window.addEventListener('load',()=>{setTimeout(()=>document.body.classList.add('loaded'),1800)});
const observer=new IntersectionObserver((entries)=>{entries.forEach(e=>{if(e.isIntersecting)e.target.classList.add('visible')})},{threshold:.12});
document.addEventListener('DOMContentLoaded',()=>{document.querySelectorAll('.reveal').forEach(el=>observer.observe(el));});

// DROPPD accordions: top feature cards, setup steps, and why cards
document.addEventListener('DOMContentLoaded',function(){
  function singleToggle(selector, card){
    var isOpen=card.classList.contains('open');
    document.querySelectorAll(selector).forEach(function(c){c.classList.remove('open');});
    if(!isOpen){card.classList.add('open');}
  }
  document.querySelectorAll('.dm-si').forEach(function(card){card.addEventListener('click',function(){singleToggle('.dm-si',this);});});
  document.querySelectorAll('.dm-scard').forEach(function(card){card.addEventListener('click',function(e){e.stopPropagation();singleToggle('.dm-scard',this);});});
  document.querySelectorAll('.dm-snum').forEach(function(num){num.addEventListener('click',function(){var step=this.closest('.dm-step');var card=step&&step.querySelector('.dm-scard');if(card){singleToggle('.dm-scard',card);}});});
  document.querySelectorAll('.dm-wc').forEach(function(card){card.addEventListener('click',function(e){e.stopPropagation();singleToggle('.dm-wc',this);});});
});

// DROPPD homepage Featured Drops image refresh
document.addEventListener('DOMContentLoaded',function(){
  var apexOldCard=document.querySelector('.dm-col-g .dm-pc[href="/products/https-droppd-co-za-products-droppd-facet-smart-ring"]');
  if(apexOldCard){apexOldCard.setAttribute('href','/products/droppd-facet-smart-ring');}

  var featuredDropImages={
    '/products/droppd-signature-smart-ring':'https://cdn.shopify.com/s/files/1/0986/4134/6879/files/droppd-signature-smart-ring-clean-preview.png?v=1783106530',
    '/products/droppd-facet-smart-ring':'https://cdn.shopify.com/s/files/1/0986/4134/6879/files/droppd-apex-smart-ring-clean-preview.png?v=1783106584',
    '/products/droppd-rose-smart-ring':'https://cdn.shopify.com/s/files/1/0986/4134/6879/files/droppd-rose-smart-ring-clean-preview.png?v=1783106538',
    '/products/retro-elite-smart-ring':'https://cdn.shopify.com/s/files/1/0986/4134/6879/files/droppd-retro-elite-smart-ring-clean-preview.png?v=1783106546'
  };

  Object.keys(featuredDropImages).forEach(function(href){
    document.querySelectorAll('.dm-col-g .dm-pc[href="'+href+'"]').forEach(function(card){
      var image=card.querySelector('img');
      if(!image){return;}
      image.src=featuredDropImages[href];
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
    });
  });
});

// DROPPD homepage lifestyle and internal-parts gallery refresh
document.addEventListener('DOMContentLoaded',function(){
  var galleryImages=[
    {src:'https://cdn.shopify.com/s/files/1/0986/4134/6879/files/droppd-lifestyle-coffee-ring.png?v=1783118216',alt:'DROPPD smart ring worn while holding a coffee cup'},
    {src:'https://cdn.shopify.com/s/files/1/0986/4134/6879/files/droppd-exploded-black-ring-components.png?v=1783118240',alt:'Exploded view of a black smart ring with internal components'},
    {src:'https://cdn.shopify.com/s/files/1/0986/4134/6879/files/droppd-lifestyle-phone-ring.png?v=1783118224',alt:'DROPPD rose gold smart ring worn while using a phone'},
    {src:'https://cdn.shopify.com/s/files/1/0986/4134/6879/files/droppd-exploded-rose-gold-ring-components.png?v=1783118247',alt:'Exploded view of a rose gold smart ring with internal components'},
    {src:'https://cdn.shopify.com/s/files/1/0986/4134/6879/files/droppd-lifestyle-recovery-ring.png?v=1783118233',alt:'DROPPD black smart ring worn during a recovery moment'},
    {src:'https://cdn.shopify.com/s/files/1/0986/4134/6879/files/droppd-ring-internal-parts-macro.png?v=1783118255',alt:'Smart ring internal sensor parts displayed beside an assembled ring'}
  ];

  document.querySelectorAll('.dm-photos .dm-ph img').forEach(function(image,index){
    if(!galleryImages[index]){return;}
    image.src=galleryImages[index].src;
    image.alt=galleryImages[index].alt;
    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
  });
});
